import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import authReducer from 'store/reducers/auth';
import dndReducer from 'store/reducers/dnd';
import contentReducer from 'store/reducers/content';
import dbReducer from 'store/reducers/db';
import integrationReducer from 'store/reducers/integration';
import paymentReducer from 'store/reducers/payment';

const rootReducer = combineReducers({
    auth: authReducer,
    dnd: dndReducer,
    content: contentReducer,
    db: dbReducer,
    integration: integrationReducer,
    payment: paymentReducer
})

const logger = store => {
return next => {
    return action => {
        const result = next(action);
        return result;
    }
}
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(logger, thunk)));

export default store
